import React from 'react';
import { ContainerApuracao } from './styles';
import FooterDefault from '~/components/FooterDefault';
import { SearchFilters } from './components/SearchFilters';
import { GridIcms } from './components/GridIcms';
import { TotalizadoresIcms } from './components/TotalizadoresIcms';
import { PrintButton } from './components/PrintButton';
import FormDefault from '~/components/FormDefault';

export const ApuracaoIcmsContent: React.FC = () => {
  return (
    <ContainerApuracao>
      <FormDefault
        codTela={298}
        title="Apuração Icms"
        onSave={() => Promise.resolve()}
        onCancel={() => []}
        onClearFields={() => []}
        onNew={() => []}
        onDelete={() => []}
        onReturnSearch={() => []}
        isDelete={false}
        isNew={false}
        isCancel={false}
        isClear={false}
        isSave
        customButtons={<PrintButton />}
      >
        <section className="content">
          <SearchFilters />
          <GridIcms />
          <TotalizadoresIcms />
        </section>
      </FormDefault>
    </ContainerApuracao>
  );
};
